var _path, _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 70,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3V2.5H14H10H9.5V3C9.5 3.00908 9.5 3.01815 9.5 3.0272C9.49995 3.23924 9.49991 3.4453 9.52276 3.61526C9.54852 3.80686 9.61129 4.0255 9.79289 4.20711C9.9745 4.38871 10.1931 4.45148 10.3847 4.47724C10.5547 4.50009 10.7608 4.50005 10.9728 4.5C10.9819 4.5 10.9909 4.5 11 4.5H13C13.0091 4.5 13.0181 4.5 13.0272 4.5C13.2392 4.50005 13.4453 4.50009 13.6153 4.47724C13.8069 4.45148 14.0255 4.38871 14.2071 4.20711C14.3887 4.0255 14.4515 3.80686 14.4772 3.61526C14.5001 3.4453 14.5 3.23924 14.5 3.0272C14.5 3.01815 14.5 3.00908 14.5 3Z",
    stroke: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 2.5,
    width: 11,
    height: 19,
    rx: 1.5,
    stroke: "#222222",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1,
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLight);
export default __webpack_public_path__ + "static/media/phone_light.8ecb89abfc9ced6a567daffa9fe952de.svg";
export { ForwardRef as ReactComponent };